(function () {
    'use strict';

    angular
        .module('app')
        .controller('UsersAddController', UsersAddController);

    UsersAddController.$inject = ['debug', '$stateParams', '$scope', '$state', 'API', 'i18n', 'helpers', '$q', '$timeout',];

    function UsersAddController(debug, $stateParams, $scope, $state, API, i18n, helpers, $q, $timeout) {
        $scope.$state = $state;
        var vm = this;
        vm.id = $stateParams.id;
        vm.isAdding = false;
        vm.schoolIsValid = false;
        vm.schoolsList = [];
        vm.groupsList = [];
        vm.groups = [];
        vm.existingGroupsToConnectTo = [];
        vm.add = add;
        vm.user = {
            first_name: '',
            last_name: '',
            user_type: $stateParams.userType ? $stateParams.userType : 'parent',
            language: 'sv',
            loginTeacher: {
                email_subscribed: 1,
            },
            loginStudent: {
                username: '',
            }
        };
        vm.numberOfExistingGroupsSelected = 0;
        vm.willRecieveWelcomeMail = 1;

        vm.generatePassword = generatePassword;
        vm.updateSelectedGroups = updateSelectedGroups;
        vm.onEmailPaste = onEmailPaste;
        vm.onChangeFirstName = onChangeFirstName;

        vm.schoolChoice = 'existing-school';
        vm.groupChoice = 'existing-group';

        vm.userTypes = [
            'parent',
            'teacher',
            'child',
            'student',
            'iusadmin',
        ];

        vm.loadingState = {
            'userIsLoading': false,
            'schoolGroups': false,
        };


        activate();

        function activate() {
            loadSchools();

            $scope.$watch('vm.user.fk_school_id', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue && newValue > 0) {
                    vm.groupsList = [];
                    loadSchoolGroups();
                } else {
                    vm.schoolIsValid = false;
                }
            });

            if ($stateParams.schoolId) {
                vm.user.fk_school_id = $stateParams.schoolId;
            }

            if ($stateParams.groupId) {
                vm.user.fk_group_id = $stateParams.groupId;
            }
        }

        function connectToSelectedExistingGroups(createdUserId) {
            var selectedGroupIds = getSelectedGroups();
            var classConnectPromises = [];
            angular.forEach(selectedGroupIds, function (groupId) {
                var classConnectPromise = API.User.addToGroup({
                    id: createdUserId,
                    target: groupId,
                }).$promise;
                classConnectPromises.push(classConnectPromise);

            });
            $q.all(classConnectPromises)
                .then(function () {
                    window.toast({
                        message: i18n.get('CONNECTED_TO_SELECTED_GROUPS'),
                        autoRemoveTime: 5000,
                        type: 'success'
                    });
                    vm.isAdding = false;
                    sendWelcome(createdUserId);
                    $state.go('users.edit', { id: createdUserId });
                }, function () {
                })
                .finally(function () {
                    vm.isAdding = false;

                });
        }

        function generatePassword() {
            vm.user.loginTeacher.password = helpers.generatePassword(6);
        }

        function getSelectedGroups() {
            var selectedGroupIds = [];
            angular.forEach(vm.groups, function (group) {
                if (group.checked) {
                    selectedGroupIds.push(group.id);
                }
            });
            return selectedGroupIds;
        }

        function loadSchools() {
            vm.loading = true;
            API.School.search({
                'per-page': 0,
                'status': 'verified',
                'sort': 'name',
                'fields': 'id,name,district'
            })
                .$promise
                .then(function (list) {
                    angular.forEach(list.items, function (school) {
                        vm.schoolsList.push({
                            value: school.id,
                            label: school.name,
                            subLabel: school.district,
                        });
                    });
                    if ($stateParams.schoolId) {
                        vm.user.fk_school_id = parseInt($stateParams.schoolId, 10);
                    }
                }, function () {
                    debug.error('Could not load schools.');
                })
                .finally(function () {
                    vm.loading = false;
                });
        }

        function loadSchoolGroups() {
            vm.loadingState.schoolGroups = true;
            API.Group.search({
                fk_school_id: vm.user.fk_school_id,
                // Limit per-page to avoid crashing browser on look at "Hemanvändare"
                'per-page': 100
            })
                .$promise
                .then(function (response) {
                    vm.groups = response.items;
                    if ($stateParams.groupId) {
                        angular.forEach(vm.groups, function (group) {
                            if (group.id === parseInt($stateParams.groupId, 10)) {
                                group.checked = true;
                            }
                        });
                    }
                    vm.loadingState.schoolGroups = false;
                    updateSelectedGroups();
                }, function () {
                })
                .finally(function () {
                    vm.loadingState.schoolGroups = false;
                });
        }

        function onEmailPaste(ev) {
            $timeout(function () {
                if (helpers.validateEmail(ev.target.value)) {
                    var name = ev.target.value.split('@')[0];
                    if (name.split('.').length > 1) {
                        vm.user.first_name = vm.user.first_name ? vm.user.first_name : name.split('.')[0];
                        vm.user.last_name = vm.user.last_name ? vm.user.last_name : name.split('.')[1];
                    } else if (name.split('_').length > 1) {
                        vm.user.first_name = vm.user.first_name ? vm.user.first_name : name.split('_')[0];
                        vm.user.last_name = vm.user.last_name ? vm.user.last_name : name.split('_')[1];
                    } else {
                        vm.user.first_name = vm.user.first_name ? vm.user.first_name : name;
                    }
                }
            }, 100);
        }

        function onChangeFirstName() {
            var randomString = helpers.generateString(4, 'abcdefghijklmnopqrstuvwxyz'),
                firstName = vm.user.first_name
                    .toLowerCase()
                    .replace(/[^a-z]/, '')
                    .substring(0, 4);

            vm.user.loginStudent.username = (firstName + randomString).substring(0, 4);
        }

        function updateSelectedGroups() {
            var groups = getSelectedGroups();
            vm.numberOfExistingGroupsSelected = groups.length;
        }

        function sendWelcome(userId) {
            if ((vm.user.user_type === 'teacher' || vm.user.user_type === 'parent') && vm.willRecieveWelcomeMail) {
                var promise = API.User.sendWelcome({
                    id: userId
                }).$promise;

                promise.then(function (response) {
                    if (response.success) {
                        window.toast({
                            message: i18n.get('WELCOME_MAIL_SENT'),
                            autoRemoveTime: 5000,
                            type: 'success'
                        });
                    } else {
                        window.toast({
                            message: i18n.get('WELCOME_MAIL_NOT_SENT'),
                            type: 'danger'
                        });
                    }
                }, function () {
                });
            }
        }

        function connectToAllGroups(createdUserId) {

            var classConnectPromises = [];
            angular.forEach(vm.groups, function (group) {
                var classConnectPromise = API.User.addToGroup({
                    id: createdUserId,
                    target: group.id,
                }).$promise;
                classConnectPromises.push(classConnectPromise);

            });
            $q.all(classConnectPromises)
                .then(function () {
                    window.toast({
                        message: i18n.get('CONNECTED_TO_ALL_GROUPS'),
                        autoRemoveTime: 5000,
                        type: 'success'
                    });
                    sendWelcome(createdUserId);
                    $state.go('users.edit', { id: createdUserId });
                }, function () {
                })
                .finally(function () {
                    vm.isAdding = false;
                });


        }

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                if (vm.schoolChoice === 'existing-school') {
                    if (angular.isObject(vm.user.school)) {
                        delete vm.user.school;
                    }
                    if (vm.groupChoice === 'existing-group' && angular.isObject(vm.user.group)) {
                        delete vm.user.group;
                    } else if (vm.groupChoice === 'all-groups') {
                        // Remove keys as BE uses these as indication for what to do
                        if (angular.isObject(vm.user.group)) {
                            delete vm.user.group;
                        }
                    }
                } else if (vm.schoolChoice === 'new-school' && angular.isString(vm.user.fk_school_id)) {
                    delete vm.user.fk_school_id;
                }

                var newUser = new API.User(vm.user);

                var promise = newUser.$save();

                promise.then(function (response) {
                    window.toast({
                        message: i18n.get('SAVED'),
                        autoRemoveTime: 5000,
                        type: 'success'
                    });

                    if (vm.groupChoice === 'all-groups') {
                        connectToAllGroups(response.id);
                    } else if (vm.groupChoice === 'existing-group') {
                        connectToSelectedExistingGroups(response.id);
                    } else {
                        sendWelcome(response.id);
                        $state.go('users.edit', { id: response.id });
                    }

                }, function (response) {
                    debug.log(response);
                })
                    .finally(function () {
                        vm.isAdding = false;
                    });
            }
        }
    }
})();